import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouse = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_20243",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_20243)",
		children: /* @__PURE__ */ _jsx("path", { d: "M5.99997 19.0001H9.34615V13.0578H14.6538V19.0001H18V10.0001L12 5.48091L5.99997 10.0001V19.0001ZM4.5 20.5001V9.25016L12 3.60596L19.5 9.25016V20.5001H13.1538V14.5578H10.8461V20.5001H4.5Z" })
	})]
});
export default SvgHouse;
